// TODO: Add ad slots for immoweltat
export const adSlots = [];
export const mobileAdSlots = [];
